// extracted by mini-css-extract-plugin
export default {"inline":"AccionaBigButton_inline__7yubn","slim":"AccionaBigButton_slim__AbyPg"};